



























































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import * as Types from '../../mini'
import * as _ from 'underscore'
import { env } from '@ivy/fts/envInfo/envInfo'

@Component({})
export default class Course extends Vue {
  @Prop() data: Types.CourseComp
  @Prop({ default: () => {} }) config: any
  vip_config: any = null
  emptyAlbum: any = [
    {
      id: 'empty1',
      play_count: 0,
      duration: 0,
      pic_url: require('../../images/pic-two.png'),
      title: '专辑名称专辑名称，最多显示2行 专辑名称专辑名称，最多显示2行',
      introduction: '专辑描述最多显示1行',
      audio_names: [],
    },
    {
      id: 'empty2',
      play_count: 0,
      duration: 0,
      pic_url: require('../../images/pic-two.png'),
      title: '专辑名称专辑名称，最多显示2行 专辑名称专辑名称，最多显示2行',
      introduction: '专辑描述最多显示1行',
      audio_names: [],
    },
  ]
  publishedAlbums: any = []
  @Watch('data.courses')
  async getPubAlbums() {
    if (this.config && this.config.vip_config) {
      this.vip_config = this.config.vip_config
    }
    if (this.data.courses.length > 0) {
      let cCourseIds = this.data.courses
        .filter(item => item._type === 'english')
        .map(t => t.id)
      let kCourseIds = this.data.courses
        .filter(item => item._type === 'knowledge')
        .map(t => t.id)
      Promise.all([
        cCourseIds.length > 0
          ? this.$axios
              .post('/api/m-course/cCourse/course/courseByIds', {
                ids: cCourseIds,
              })
              .then(res => res.data)
          : [],
        kCourseIds.length > 0
          ? this.$axios
              .post('/api/m-course/kCourse/course/courseByIds', {
                ids: kCourseIds,
              })
              .then(res => res.data)
          : [],
      ]).then(re => {
        const englishMapper = _.indexBy(re[0], 'id')
        const knowledgeMapper = _.indexBy(re[1], 'id')
        let data = []
        for (let i = 0; i < this.data.courses.length; i++) {
          let item = null
          let baseItem = this.data.courses[i]
          if (baseItem._type === 'english') {
            if (!re[0].length) break
            item = englishMapper[baseItem.id]
          } else if (baseItem._type === 'knowledge') {
            if (!re[1].length) break
            item = knowledgeMapper[baseItem.id]
          }
          if (item) {
            if (!item.type) {
              item.type = baseItem._type
            }
            data.push(item)
          }
        }
        this.publishedAlbums = data
      })
    } else {
      this.publishedAlbums = []
    }
  }
  //课时
  getCourseStudyCount(item) {
    return item.unit_num || 0
  }
  async created() {
    this.getPubAlbums()
  }
  get getClass() {
    if (this.canShowWhite && this.data.whiteCard) {
      return 'white-card'
    } else {
      return ''
    }
  }
  get noticeStyle() {
    return `background: ${this.vip_config.back_color};
           color:${this.vip_config.font_color};
           border-radius: 0px ${this.data.radius}px 0px 10px`
  }
  get coursesBoxStyle() {
    return {
      'background-color': this.data.bgColor,
      padding: `0 ${this.data.compMargin}px`,
    }
  }
  get canShowWhite() {
    return true
  }
  get courseBoxStyle() {
    if (this.canShowWhite) {
      if (this.data.whiteCard) {
        return {
          margin: `${this.data.spacing / 2}px`,
          'border-radius': this.data.radius + 'px',
          background: '#fff',
          padding: '7px',
        }
      } else {
        return {
          margin: `${this.data.spacing / 2}px`,
          background: this.data.bgColor || '#f5f6f6',
          padding: '0px',
        }
      }
    } else {
      return {
        margin: `${this.data.spacing / 2}px`,
        'border-radius': this.data.radius + 'px',
        background:
          this.data.lineRule === 'one'
            ? '#fff'
            : this.data.bgColor || '#f5f6f6',
      }
    }
  }
  get courseItemStyle() {
    if (this.data.whiteCard) {
      return {
        margin: `${this.data.spacing / 2}px 0`,
        'border-radius': this.data.radius + 'px',
        background: '#fff',
      }
    } else {
      return {
        margin: `${this.data.spacing / 2}px 0`,
        background: this.data.bgColor || '#f5f6f6',
      }
    }
  }

  get coverStyle() {
    return {
      'border-radius': this.data.radius + 'px',
      'object-fit': this.data.filling,
    }
  }
  get textStyle() {
    return {
      'text-align': this.data.fontAlign,
      'font-weight': this.data.fontWeight,
    }
  }
  get textDescStyle() {
    return {
      'text-align': this.data.fontAlign,
    }
  }

  get hasAlbum() {
    return this.data.courses && this.data.courses.length
  }
  get courseList() {
    return this.hasAlbum ? this.publishedAlbums : this.emptyAlbum
  }
  goCourse(value) {
    let conf = env.getParams(value.type, value.id)
    env.commonJump(conf.path, conf.params, { showCancelButton: true })
  }
  numberFormat(value) {
    var param = {
      value: '0',
      unit: '',
    }
    var k = 10000,
      sizes = ['', '万', '亿', '万亿'],
      i
    if (value < k) {
      param.value = value
      param.unit = ''
    } else {
      i = Math.floor(Math.log(value) / Math.log(k))
      let result = value / Math.pow(k, i)
      if (Number.isInteger(result)) {
        param.value = result + ''
      } else {
        param.value = result.toFixed(1)
      }
      param.unit = sizes[i]
    }
    return param.value + param.unit
  }
}
